import { useState } from "react";
import { toast } from "sonner";
import { Download, Share2 } from "lucide-react";
import { toolCardBlob } from "@/components/tools/toolCard";
import { track } from "@/lib/toolTrack";

// Share a tool (or a check's band only) with a link that shows a proper preview
export const ToolShare = ({ tool, card }) => {
  const [busy, setBusy] = useState(false);
  const url = `${window.location.origin}/api/tools/share/${tool.slug}`;
  const file = async () => new File([await toolCardBlob(card)], `mindful-me-${tool.slug}.png`, { type: "image/png" });
  const share = async () => {
    setBusy(true);
    try {
      const f = await file();
      const data = { title: tool.name, text: `${card.line} ${card.sub}`, url };
      if (navigator.canShare?.({ ...data, files: [f] })) await navigator.share({ ...data, files: [f] });
      else if (navigator.share) await navigator.share(data);
      else { await navigator.clipboard.writeText(`${data.text} ${url}`); toast.success("Link copied. Paste it anywhere 💜"); }
      track(tool.slug, "share");
    } catch (e) { if (e?.name !== "AbortError") toast.error("Couldn't share right now"); }
    finally { setBusy(false); }
  };
  const save = async () => {
    try {
      const a = document.createElement("a");
      a.href = URL.createObjectURL(await file()); a.download = `mindful-me-${tool.slug}.png`; a.click();
      setTimeout(() => URL.revokeObjectURL(a.href), 2000);
      track(tool.slug, "share");
    } catch { toast.error("Couldn't create the image"); }
  };
  return (
    <div className="flex flex-wrap gap-2" data-testid="tool-share">
      <button onClick={share} disabled={busy} className="mm-btn-ghost !py-2 !px-4 text-sm" data-testid="tool-share-btn"><Share2 size={15} />Share</button>
      <button onClick={save} className="mm-btn-ghost !py-2 !px-4 text-sm" data-testid="tool-save-image"><Download size={15} />Save image</button>
    </div>
  );
};
